import { Link } from "react-router-dom";
import { useState, createContext, useContext } from "react";
import "./Sidebar.css";

// Create a context to share sidebar state
const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);

const Sidebar = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <SidebarContext.Provider value={{ isOpen }}>
            <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
                ☰
            </button>
            <div className={`sidebar ${isOpen ? "open" : ""}`}>
                
                <ul>
                    <li><Link to="/dashboard" onClick={() => setIsOpen(false)}>Dashboard</Link></li>
                    <li><Link to="/users" onClick={() => setIsOpen(false)}>Manage Users</Link></li>
                </ul>
            </div>
            <div className={`content-wrapper ${isOpen ? "shifted" : ""}`}>
                {children}
            </div>
        </SidebarContext.Provider>
    );
};

export default Sidebar;
